<sm-spinner [loading]="loading$"></sm-spinner>
<div class="flex flex-row gap-5">
  <div class="flex flex-col gap-4 w-3/4">
    <div class="content">
      <div class="h-fit flex flex-col gap-4" *ngFor="let blocks of metadataBlocks">
        <sm-block-builder [blocks]="blocks"></sm-block-builder>
      </div>
    </div>
    <!-- Form -->
    <div class="content">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </div>
  </div>
  <!-- Meta Blocks -->
  <div class="flex flex-col gap-2 w-1/4">
    <sm-status [status]="`ppm.status.${status}`" [extra]="ppm?.etapeProcess || ''"></sm-status>
    <div class="content h-fit flex flex-col gap-4" *ngFor="let blocks of controlBlocks">
      <sm-block-builder [blocks]="blocks"></sm-block-builder>
    </div>
  </div>
</div>